

import React, { useState, useEffect, useRef} from "react";

function LoadingComp() {
  const appearIn = 800;
  const [loaded, setLoaded] = useState(appearIn === 0);
  const timeoutRef = useRef(null);
  
  useEffect(() => {
    if (appearIn === 0) return;
  
    timeoutRef.current = setTimeout(() => setLoaded(true), appearIn);
  
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [appearIn]);
  
  if (!loaded) {
    return null;
  }

  return (
    <h1>loading</h1>
  );
  
}

export default LoadingComp;

